<template>
  <div>
    <EmailGrabberPopup
      @close="toggleGrabber"
      :grabberActive="grabberActive"
      :freePlan="freePlan"
      :payPlan="payPlan"
      :planId="planId"
      class="overflow-y-hidden"
    >
    </EmailGrabberPopup>
    <div>
      <!-- page meta -->
      <Head>
        <title>Monetize & Protect Your Podcast with Platforma</title>
        <link
          rel="icon"
          :href="$filters.public_path('favicon.png')"
          type="favicon"
        />
        <meta
          name="description"
          content="Sell exclusive content your subscribers can't get anywhere else."
        />
      </Head>
    </div>
    <!-- content start -->
    <div
      class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
    >
      <!-- ===================== HERO SECTION ===================== -->

      <section
        id="section1"
        class="hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
        :style="backgroundImageStyleMain"
      >
        <div class="mt-0 bg-transparent px-[25px] xl:px-0">
          <h1
            class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Build and manage your dream podcast with Platforma
          </h1>

          <p
            class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
          >
            Create the perfect homebase for your podcasts, where you can
            monetize it on your terms.
          </p>

          <!-- captcher email widget -->
          <EmailCaptureHeaderWidget />

          <img :src="$filters.media_path('/images/stars.svg')" alt="" />
        </div>

        <div class="mb-[30px] mt-[30px] lg:mt-0 z-10 px-[15px]">
          <video
            class="lg:max-w-[518px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="$filters.media_path('/videos/sell-your-podcast-com.mp4')"
              type="video/mp4"
            />
          </video>
        </div>

        <!-- JOIN US SECTION -->
      </section>

      <div
        class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[50px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
      >
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
        <h2
          class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
        >
          JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
        </h2>
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      </div>
    </div>
    <!-- MONETIZE SECTION -->
    <section
      class="mx-[25px] mt-[45px] content-center rounded-[19px] rounded-b-none bg-[#EDFAFE] md:rounded-t-[60px] lg:mx-auto lg:mt-0 lg:flex xl:h-[1000px] xl:w-[1400px]"
    >
      <div class="py-10 px-[25px] lg:mx-auto lg:flex-col lg:pt-[110px]">
        <h3 class="mx-0 text-center text-xs font-extrabold text-[#49CCF9]">
          MONETIZE
        </h3>

        <h2
          class="top-full mt-[20px] px-0 text-center text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Podcast subscriptions on your website.
        </h2>

        <p
          class="mx-auto mt-5 text-center text-sm font-normal leading-[25px] text-[#292d34] lg:mt-[50px] lg:w-[820px]"
        >
          Podcasters now have a full podcast experience that can be added to any
          website domain creating their own platform.
        </p>

        <div class="z-30 mt-[25px] xl:mt-10">
          <img
            loading="lazy"
            class="mx-auto lg:max-w-[860px]"
            :src="
              $filters.media_path(
                '/images/member-ui-of-comedy-show-podcasts.png'
              )
            "
            alt="Your entire podcast library in a VIP membership site for members to freely access."
          />
        </div>
      </div>
    </section>
    <div
      class="mx-[25px] h-[63px] rounded-[19px] rounded-t-none bg-[#49cdf92a] pt-[11px] text-center md:rounded-b-[60px] lg:mx-auto xl:w-[1400px]"
    >
      <div
        class="mx-auto my-0 flex h-[42px] w-[142px] justify-center rounded-[9px] bg-transparent align-middle hover:bg-white"
      >
        <button
          @click="toggleGrabber('free', null)"
          type="button"
          class="text-sm font-semibold text-[#292d34]"
        >
          Get Started
        </button>

        <img
          :src="$filters.media_path('/images/arrow-right-blue.svg')"
          alt=""
          class="ml-2 w-[17px]"
        />
      </div>
    </div>
    <!-- INTERFACE SECTION -->
    <section
      class="mx-[25px] mt-[45px] content-center rounded-[19px] bg-[#2d8bff10] py-10 px-[25px] md:rounded-[60px] lg:mx-auto lg:flex lg:pt-[110px] xl:h-[748px] xl:w-[1400px]"
    >
      <div class="z-20 mx-auto justify-center gap-1 py-0 lg:flex">
        <div class="text-left lg:max-w-[500px]">
          <div
            id="text_interface"
            class="text-xs font-bold tracking-wide text-[#2D8CFF]"
          >
            INTERFACE
          </div>

          <h2
            class="top-full mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Familiar layout members will love.
          </h2>

          <hr
            class="mt-[30px] ml-0 h-[5px] w-[100px] rounded-full bg-[#2D8CFF]"
          />

          <p
            class="mt-[50px] mb-10 text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Your followers won’t miss a beat, and will easily move over to your
            site to listen to the next exclusive podcast, AND pay for it.
          </p>

          <button
            @click="toggleGrabber('free', null)"
            type="button"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#2d8bff] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
          >
            Get Started
          </button>
        </div>

        <div class="z-30 mt-[25px] max-w-[645px] xl:mt-0">
          <img
            loading="lazy"
            class="lg:w-[650px]"
            :src="
              $filters.media_path(
                '/images/podcast-episode-list-in-community-site.png'
              )
            "
            alt="Podcast episode list"
          />
        </div>
      </div>
    </section>
    <!-- FLEXIBILITY SECTION -->
    <section
      class="mx-[25px] mt-[45px] content-center rounded-[19px] bg-[#2d8bff10] py-10 px-[25px] md:rounded-[60px] lg:mx-auto lg:flex lg:pt-[110px] xl:h-[748px] xl:w-[1400px]"
    >
      <div class="z-20 mx-auto justify-center gap-1 py-0 lg:flex">
        <div class="text-left lg:max-w-[500px]">
          <div
            id="text_flexibility"
            class="text-xs font-bold tracking-wide text-[#2D8CFF]"
          >
            FLEXIBILTY
          </div>

          <h2
            class="top-full mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            MP3 Audio and MP4 Video Support.
          </h2>

          <hr
            class="mt-[30px] ml-0 h-[5px] w-[100px] rounded-full bg-[#2D8CFF]"
          />

          <p
            class="mt-[50px] mb-10 text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            The podcast player for your member is developed to play whatever
            format you decide to upload to your membership site.
          </p>

          <button
            @click="toggleGrabber('free', null)"
            type="button"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#2d8bff] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
          >
            Get Started
          </button>
        </div>

        <div class="z-30 mt-[25px] max-w-[645px] xl:mt-14">
          <img
            loading="lazy"
            class="lg:w-[650px]"
            :src="
              $filters.media_path(
                '/images/podcast-player-to-make-money-online.png'
              )
            "
            alt="Podcast player to listen to your favorite podcast and actually monetize it on an offical homebase."
          />
        </div>
      </div>
    </section>
    <!-- SEXY TESTIMONIALS SECTION -->
    <section
      class="mx-auto mt-[50px] lg:mt-[100px] max-w-[1140px] px-[25px] text-center xl:px-0"
    >
      <div class="py-10 px-[25px] lg:mx-auto lg:flex-col">
        <h3 class="mx-0 text-center text-xs font-extrabold text-[#2D8CFF]">
          TESTIMONAILS
        </h3>

        <h2
          class="top-full mt-[20px] px-0 text-center text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Make your podcast more exclusive with unlimited ways to monetize it.
        </h2>
      </div>

      <CarouselTestimonialSimple
        :pagination="true"
        :timeout="6000"
        class="carousel lg:w-[1000px] md:h-[400px] h-[350px] bg-none relative mx-auto"
        v-slot="{ currentSlide }"
      >
        <Slide v-for="(slide, index) in carouselSlides" :key="index">
          <div
            v-show="currentSlide == index + 1"
            class="slide-info absolute mx-auto bg-none w-full h-full rounded-[10px] sm:rounded-[60px]"
          >
            <img
              :src="$filters.media_path(`/images/${slide}.png`)"
              alt="Build your own podcast delivery website on your own domain to make more revenue from your Podcast."
              class="mx-auto md:w-[800px] rounded-[20px] sm:rounded-[60px]"
            />
          </div>
        </Slide>
      </CarouselTestimonialSimple>
    </section>
    <!-- ===================== CTA BLOCK ===================== -->
    <ProtectCtaBlock />
  </div>
</template>

<!-- CONTENT END -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';

export default {
  layout: DefaultLayout
};
</script>

<script setup>
import { ref, computed } from 'vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import EmailIntegrationsSlider from '../Components/EmailIntegrationsSlider.vue';
import CarouselTestimonialSimple from '../Components/CarouselTestimonialSimple.vue';
import Slide from '../Components/Slide.vue';
import ProtectCtaBlock from '../Components/ProtectCtaBlockFooter.vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';

const carouselSlides = [
  'testimonial-1-make-money-online',
  'testimonial-2-make-money-online',
  'testimonial-3-make-money-online',
  'testimonial-4-make-money-online'
];

const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};

const backgroundImageStyleMain = computed(() => {
  const imagePath =
    '../../../../media/images/platforma-header-background-eclipse.svg';
  return {
    '--before-background-image': `url(${imagePath})`
  };
});
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
